<template>
  <div class="avatar" :class="getSize(size)">
    <a v-if="clickable && typeof clickable === 'string'" :href="clickable">
      <img
          :src="img"
          :alt="alt"
          :class="[getClasses(shadow, circular, borderRadius)]"
      />
    </a>
    <img
        v-else
        :src="img"
        :alt="alt"
        :class="[getClasses(shadow, circular, borderRadius)]"
        @click="handleClick"
        :style="{ cursor: clickable ? 'pointer' : 'default' }"
    />
  </div>
</template>

<script>
export default {
  name: "SoftAvatar",
  props: {
    img: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: null,
    },
    shadow: {
      type: String,
      default: null,
    },
    borderRadius: {
      type: String,
      default: null,
    },
    circular: Boolean,
    clickable: {
      type: [String, Function],
      default: null,
    },
  },
  methods: {
    getSize: (size) => (size ? `avatar-${size}` : null),
    getClasses: (shadow, circular, borderRadius) => {
      let shadowValue, circularValue, borderRadiusValue;

      if (shadow) {
        shadowValue = shadow === "regular" ? "shadow" : `shadow-${shadow}`;
      } else {
        shadowValue = null;
      }

      circularValue = circular ? "rounded-circle" : null;

      borderRadiusValue = borderRadius ? `border-radius-${borderRadius}` : null;

      return `${shadowValue} ${circularValue} ${borderRadiusValue}`;
    },
    handleClick() {
      if (typeof this.clickable === "function") {
        this.clickable();
      }
    },
  },
};
</script>
